import { render, staticRenderFns } from "./ViberProviderTariff.vue?vue&type=template&id=6c34ba8a&"
import script from "./ViberProviderTariff.vue?vue&type=script&lang=ts&"
export * from "./ViberProviderTariff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports